(() => {
 'use strict';
 function init(scope=document){
  scope.querySelectorAll('[data-fg-unified-root]').forEach(root=>{
   if(root.dataset.ready)return;
   const data=root.querySelector('[data-fg-variants]');
   let variants=[]; try{variants=JSON.parse(data?.textContent||'[]')}catch(e){return}
   const full=root.querySelector('[data-fg-variant]');
   const controls=[...root.querySelectorAll('[data-fg-option]')];
   if(!full||!variants.length)return;
   root.dataset.ready='true';
   const purchase=root.dataset.fgPurchase==='true';
   function allowed(index,prefix){return [...new Set(variants.filter(v=>prefix.every((x,i)=>v.options[i]===x)).map(v=>v.options[index]))]}
   function paint(v,updateUrl=false){
    if(!v)return;
    full.value=String(v.id);
    controls.forEach((select,i)=>{
      const values=allowed(i,v.options.slice(0,i));
      [...select.options].forEach(o=>o.disabled=!values.includes(o.value));
      select.value=v.options[i];
    });
    const price=root.querySelector('[data-fg-price]'); if(price)price.textContent=v.price;
    const sku=root.querySelector('[data-fg-sku]'); if(sku)sku.textContent=v.sku||'—';
    const note=root.querySelector('[data-fg-selection]'); if(note)note.textContent=v.title;
    const add=root.querySelector('[data-fg-add]'); if(add){add.disabled=!purchase||!v.available;add.textContent=v.available?'Add to cart':'Currently unavailable'}
    const url=new URL(location.href); url.searchParams.set('variant',v.id);
    if(updateUrl)history.replaceState({},'',url.href);
    const quote=new URL(root.dataset.fgQuote,document.baseURI); quote.searchParams.set('product',root.dataset.fgProduct);quote.searchParams.set('sku',v.sku||'');quote.searchParams.set('variant',v.title);quote.searchParams.set('page',url.href);
    root.querySelectorAll('[data-fg-quote]').forEach(a=>a.href=quote.href);
    const wa=new URL('https://wa.me/8615951241570');wa.searchParams.set('text',['Hello FARM GUARD, I would like a quotation.','Product: '+root.dataset.fgProduct,'SKU: '+(v.sku||''),'Specification: '+v.title,'Quantity:','Delivery postcode / port:','Page: '+url.href].join('\n'));
    const waLink=root.querySelector('[data-fg-whatsapp]');if(waLink)waLink.href=wa.href;
   }
   controls.forEach((select,i)=>select.addEventListener('change',()=>{
    const wanted=controls.map(s=>s.value);
    let matches=variants.filter(v=>wanted.slice(0,i+1).every((x,j)=>v.options[j]===x));
    const exact=matches.find(v=>wanted.every((x,j)=>v.options[j]===x));
    paint(exact||matches[0],true);
   }));
   full.addEventListener('change',()=>paint(variants.find(v=>String(v.id)===full.value),true));
   root.querySelectorAll('[data-fg-select]').forEach(a=>a.addEventListener('click',e=>{const v=variants.find(x=>String(x.id)===a.dataset.fgSelect);if(!v)return;e.preventDefault();paint(v,true);root.querySelector('.dt-buy')?.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'})}));
   const main=root.querySelector('.dt-main-image');
   root.querySelectorAll('[data-fg-image]').forEach(a=>a.addEventListener('click',e=>{if(!main)return;e.preventDefault();main.removeAttribute('srcset');main.removeAttribute('sizes');main.src=a.dataset.fgImage;main.alt=a.dataset.fgAlt||'';root.querySelectorAll('[data-fg-image]').forEach(x=>x.setAttribute('aria-current',String(x===a))) }));
   root.querySelector('.dt-form')?.addEventListener('submit',e=>{const v=variants.find(v=>String(v.id)===full.value);if(!purchase||!v?.available)e.preventDefault()});
   const urlId=new URL(location.href).searchParams.get('variant');
   paint(variants.find(v=>String(v.id)===urlId)||variants.find(v=>String(v.id)===full.value)||variants[0],false);
   root.querySelector('[data-fg-options]').hidden=false;root.querySelector('.dt-complete').hidden=true;
  });
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init());else init();
 document.addEventListener('shopify:section:load',e=>init(e.target));
})();